export const APP_NAME = '우마이식당' as const
export const BASE_URL = (import.meta as ImportMeta & { env: Record<string, string> }).env['VITE_BASE_URL'] ?? '/'

/** 사업 정보 (단일 출처). 홈·푸터·문의 영역은 이 객체를 기준으로 렌더링합니다. */
export const BUSINESS = {
  name: 'Woomai Sikdang',
  nameKo: '우마이식당 범계 본점',
  phone: '',
  email: '',
  instagram: 'https://www.instagram.com/woomai_?igsh=MXFwMjA1MHJhdTV2Zw==',
  postalCode: '14072',
  address: '경기 안양시 동안구 평촌대로223번길 52 2층 우마이식당',
  serviceArea: '범계역 2층',
  hours: '월–금 11:30–21:00 · 토–일 11:30–21:00\n토·일 15:00–17:00 브레이크타임 · 매일 20:30 라스트오더',
  weekdayHours: '11:30–21:00 · 20:30 라스트오더',
  weekendHours: '11:30–21:00 · 15:00–17:00 브레이크타임 · 20:30 라스트오더',
  lastOrder: '20:30',
  representative: '문희천',
  businessNumber: '144-51-00772',
} as const
